export interface IDmsSearchFilter {
    name?: string,
    identificationCode?: string,
    sapId?: string,
    type?: string,
    category?: string,
    currentStatus?: string | null,
    currentAttribute?: string | null,
    region?: string,
    province?: string,
    city?: string,
    address?: string,
    streetNumber?: string,
    chargingStationIdentificationCode?: string,
    chargingStationStatus?: string | null,
    chargingColumnId?: string,
    certificationProtocolIdentifyingCode?: string,
    isKeyless?: boolean
}

export enum IDmsTabs {
    INFO,
    ASSOCIATION_INFO,
    DOCUMENT_REPOSITORY,
    TIMEFRAME_INFO,
    KEYLESS
    
}

// export interface UpdateDmsGeneralInfoRequest {
//     id?: 0,
//     dmsNaming?: string,
//     amadeusCode?: string,
//     amadeusWr?: string,
//     tigerCode?: string,
//     maestroCode?: string,
//     whiteLabelType?: string,
//     dmsCluster?: string,
//     dmsType?: string,
//     dmsCategory?: string,
//     serviceType?: string,
//     city17?: string,
//     city?: string,
//     address?: string,
//     streetNumber?: string,
//     region?: string,
//     province?: string,
//     municipality?: string,
//     postalCode?: string,
//     bubble?: string,
//     phoneNumber?: string,
//     cellPhoneNumber?: string,
//     fax?: string,
//     email?: string,
//     branchManager?: string,
//     branchManagerCellPhoneNumber?: string,
//     areaManager?: string,
//     country?: string
// }

export interface IGeneralTimeframe {
    dayOfWeek: string,
    isOpen: boolean,
    opening: string | null,
    breakFrom: string | null,
    breakTo: string | null,
    closing: string | null
}

export interface ISpecificTimeframe {
    dayOfWeek: string,
    dayOfMonth: string,
    isOpen: boolean,
    opening: string | null,
    breakFrom: string | null,
    breakTo: string | null,
    closing: string | null
}

export enum ITimeframeTabs {
    GENERAL_TIMEFRAME,
    SPECIFIC_TIMEFRAME,
}

export enum IActivationSetupTabs {
    WORK_DAY,
    REST_DAY,
}

export interface IGeneralDataActivation {
    generalData: {
        currentDate: string,
        dmsName: string,
        identificationCode: string,
        dmsType: string,
        afterHours: boolean,
        currentStatus: string,
        currentAttribute: string,
        lastModificationDate: string,
        lastModificationMadeBy: string,
    },
    bookAbility: boolean
}

// Response interfaces for timeframe APIs with timezone support
export interface IGeneralTimeframeResponse {
    id: number;
    generalTimeFrame: IGeneralTimeframe[];
    zoneId: string;
}

export interface ISpecificTimeframeResponse {
    id: number;
    specificTimeFrame: ISpecificTimeframe[];
    timezoneId: string;
}

